import apiClient from "./api";

export interface Unit {
  id?: number;
  code: string;
  name: string;
  short_name?: string;
  description?: string;
  status?: number | boolean;
  created_by?: number;
  updated_by?: number;
  created_at?: string;
  updated_at?: string;
}

const unitService = {
  async getUnits(): Promise<Unit[]> {
    const response = await apiClient.get("/units");
    return response.data;
  },

  async getUnit(id: number): Promise<Unit> {
    const response = await apiClient.get(`/units/${id}`);
    return response.data;
  },

  async createUnit(unit: Omit<Unit, "id">): Promise<Unit> {
    const response = await apiClient.post("/units", unit);
    return response.data.data ?? response.data;
  },

  async updateUnit(id: number, unit: Partial<Unit>): Promise<Unit> {
    const response = await apiClient.put(`/units/${id}`, unit);
    return response.data.data ?? response.data;
  },

  async deleteUnit(id: number): Promise<void> {
    await apiClient.delete(`/units/${id}`);
  },
};

export default unitService;
